import { Auth } from '@common/Auth'
import {
  DECORATION_MEAL,
  PRIVILEGE_GROUP_ID,
  PRIVILEGE_NORMAL_ID,
  PRIVILEGE_NORMAL_SERVICE_ID,
  SETMEAL_PATH
} from '@constant'
import { isSiDaProperty } from '@merchant-backend/util'
import { getPropertyId, isSiDaMember } from '@util'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import Header from '../Common/Header'
import More from '../Common/More'
import Rowbox from '../Common/Rowbox'
import Item from './Item'
import RingItem from './RingItem'
import TwoItemPerRowList from './TwoItemPerRowList'

const fakeData = [
  { id: 1, hot_tag: 1 },
  { id: 2, hot_tag: 2 },
  { id: 3, hot_tag: 3 },
  { id: 4, hot_tag: 4 }
]

const Meal = inject('decorationStore')(
  observer(props => {
    const { list, fakeDataFilter, isTeamMeal } = props
    return (
      <div>
        {list.length > 0
          ? list.map(item => (
              <Item key={item.id} {...item} isTeamMeal={isTeamMeal} />
            ))
          : fakeData
              .filter(fakeDataFilter)
              .map(item => <Item key={item.id} {...item} mode="fake" />)}
      </div>
    )
  })
)

const RingMeal = inject('decorationStore')(
  observer(props => {
    const {
      decorationStore: { themeConfig },
      list
    } = props
    return (
      <div>
        {list.length > 0
          ? list.map(item => (
              <RingItem themeConfig={themeConfig} key={item.id} {...item} />
            ))
          : fakeData.map(item => (
              <RingItem
                key={item.id}
                themeConfig={themeConfig}
                {...item}
                mode="fake"
              />
            ))}
      </div>
    )
  })
)

@Auth({
  role: [PRIVILEGE_NORMAL_ID, PRIVILEGE_NORMAL_SERVICE_ID, PRIVILEGE_GROUP_ID]
})
@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getMealList()

    // 团购套餐
    if (!isSiDaMember()) {
      this.props.store.getMealList({
        hot_tag: 4
      })
    }
  }

  getTeamMeal = team_list => {
    const { themeConfig } = this.props.store
    return (
      <>
        <Header
          title={<img src={themeConfig['teamMeal']} style={{ width: 78 }} />}
          content={<span>最热套餐，限时抢购</span>}
        />

        <Meal
          isTeamMeal={true}
          style={{ marginBottom: 10 }}
          fakeDataFilter={item => item.id == 4}
          list={team_list}
        />
      </>
    )
  }

  getMeal = (list, normal_total_all) => {
    if (getPropertyId() == 14) {
      return (
        <>
          <Header title="臻选成品" />
          <RingMeal list={list} />
        </>
      )
    }

    if (isSiDaProperty()) {
      const more = normal_total_all - list.length
      return (
        <>
          <Header title="精选套餐" />
          <TwoItemPerRowList list={list} />
          {more > 0 && (
            <More link={SETMEAL_PATH} text={`查看更多${more}个套餐`} />
          )}
        </>
      )
    }

    return (
      <>
        <Header
          title="精选套餐"
          content={<span>共{normal_total_all}个套餐</span>}
        />
        <Meal fakeDataFilter={item => item.id != 4} list={list} />
      </>
    )
  }

  render() {
    const { meal, teamMeal, mode, themeConfig } = this.props.store
    const { total_all: normal_total_all, list = [] } = meal
    const { total_all: team_total_all, list: team_list = [] } = teamMeal

    const showMeal =
      mode === 'editable' ||
      (mode === 'preview' && (normal_total_all > 0 || team_total_all > 0))

    const showTeamMeal =
      mode === 'editable' || (mode === 'preview' && team_total_all > 0)

    const showNormalMeal =
      mode === 'editable' || (mode === 'preview' && normal_total_all > 0)

    return showMeal ? (
      <Rowbox
        type={DECORATION_MEAL}
        store={this.props.store}
        style={{
          flexDirection: 'column',
          height: 'auto',
          padding: 0,
          backgroundColor: 'initial'
        }}
        vCenter={false}
      >
        <>
          {/* 团购套餐 */}
          {!isSiDaMember() &&
            showTeamMeal && (
              <div
                style={{
                  padding: '0 16px',
                  backgroundColor: themeConfig['bg'],
                  marginBottom: 10
                }}
              >
                {this.getTeamMeal(team_list)}
              </div>
            )}
          {/* 所有套餐 */}
          {showNormalMeal && (
            <div
              style={{
                padding: '0 16px',
                backgroundColor: themeConfig['bg']
              }}
            >
              {this.getMeal(list, normal_total_all)}
            </div>
          )}
        </>
      </Rowbox>
    ) : null
  }
}
